import { render, staticRenderFns } from "./inventory-dial.svg.vue?vue&type=template&id=789fb663&"
import script from "./inventory-dial.svg.vue?vue&type=script&lang=js&"
export * from "./inventory-dial.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports